import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { BeforeAfterSlider } from "./BeforeAfterSlider";

const ASSET =
  "https://customer-assets-lqy194kg.emergentagent.net/job_216d3c35-aa83-4452-b36d-63c5224739d4/artifacts";

const items = [
  {
    label: "Laser-Haarentfernung",
    before: `${ASSET}/l7z6zxk2_WhatsApp%20Image%202026-08-27%20at%2014.28.07.jpeg`,
    after: `${ASSET}/aay1qm78_WhatsApp%20Image%202026-08-27%20at%2014.28.08.jpeg`,
  },
  {
    label: "Futura",
    before: `${ASSET}/y35gtyyi_vorher.jpg`,
    after: `${ASSET}/6w49ml22_nachher.jpg`,
  },
  {
    label: "Haut-Laser",
    before: `${ASSET}/vlg2x3kr_vorher%20haut.jpeg`,
    after: `${ASSET}/c3xeksak_nachher%20haut.jpeg`,
  },
];

export const GallerySection = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#F9F8F6]"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p
            className="text-[#C5A059] text-sm tracking-[0.3em] uppercase mb-4"
            data-testid="gallery-tagline"
          >
            Vorher / Nachher
          </p>
          <h2
            className="font-playfair text-3xl md:text-4xl lg:text-5xl text-[#1A1A1A] leading-tight mb-6"
            data-testid="gallery-title"
          >
            Sichtbare <span className="italic">Resultate</span>
          </h2>
          <div className="w-16 h-[1px] bg-gradient-to-r from-[#C5A059] to-[#3d7d83] mx-auto mb-6" />
          <p className="text-[#666666] max-w-xl mx-auto">
            Echte Vorher-Nachher-Ergebnisse aus unserem Studio. Ziehen Sie den
            Regler, um den Unterschied selbst zu entdecken.
          </p>
        </div>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, index) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
            >
              {item.before && item.after ? (
                <BeforeAfterSlider
                  before={item.before}
                  after={item.after}
                  label={item.label}
                  testId={`gallery-slider-${index}`}
                />
              ) : (
                <div
                  className="relative aspect-[3/4] overflow-hidden border border-[#E5E5E5] bg-white"
                  data-testid={`gallery-placeholder-${index}`}
                >
                  <div className="absolute inset-0 flex">
                    <div className="w-1/2 h-full bg-[#EDE7E0] flex items-center justify-center">
                      <span className="text-xs tracking-widest uppercase text-[#B8A28C]">
                        Vorher
                      </span>
                    </div>
                    <div className="w-1/2 h-full bg-[#1A1A1A]/90 flex items-center justify-center">
                      <span className="text-xs tracking-widest uppercase text-[#C5A059]">
                        Nachher
                      </span>
                    </div>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-white/90 backdrop-blur flex items-center justify-center text-[#C5A059] shadow-[0_4px_20px_rgba(0,0,0,0.08)]">
                      <Sparkles size={20} />
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-[#1A1A1A]/70 to-transparent">
                    <p className="text-white font-playfair text-lg">{item.label}</p>
                    <p className="text-white/60 text-xs tracking-wider uppercase">
                      Bald verfügbar
                    </p>
                  </div>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
